<template>
  <b-modal id="referral-modal" ref="modal" size="lg" :title="title" @show="setData" @hidden="resetModal"
           @ok="handleOk" ok-title="Save">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Name</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.name)" v-model="input_data.name" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Referral Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.referral_type" v-model="input_data.referral_type" :reduce="referral_type=>referral_type.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Street</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.street)" v-model="input_data.street" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Country</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.country" v-model="input_data.country" :reduce="country=>country.id"  label="name" @input="getState"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">State</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.state" v-model="input_data.state" :reduce="state=>state.id"  label="name" @input="getCity"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">City</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.city" v-model="input_data.city" :reduce="city=>city.id"  label="name" ></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Postal Code</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.postal_code)" v-model="input_data.postal_code" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Phone</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.phone)" v-model="input_data.phone" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mobile</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.mobile)" v-model="input_data.mobile" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Email</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="email" class="form-control" :state="isValidEmail(input_data.email)" v-model="input_data.email" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea
                      id="description"
                      placeholder="Description"
                      rows="4"
                      v-model="input_data.desc"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.status"
                      :options="options.status"
                      plain
                      name="plain-inline-status"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.default"
                      :options="options.default"
                      plain
                      name="plain-inline-default"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status change by employee</label>
                <div class="col-md-8 mb-3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="input_data.is_locked"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                  >
                    Yes, Status change
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormInput, BModal, BFormTextarea, BFormRadioGroup, BFormCheckbox} from "bootstrap-vue"
import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "ReferralInput",
  components:{
    BForm,
    BFormInput,
    BModal,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckbox,
    vSelect
  },
  data(){
    return {
      title:"Add",
      input_data:{
        name:"",
        referral_type:"",
        street:"",
        country:"",
        state:"",
        city:"",
        postal_code:"",
        phone:"",
        mobile:"",
        email:"",
        desc:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      },
      options:{
        referral_type:[],
        country:[],
        state:[],
        city:[],
        status:[{text:"Active", value:"active"}, { text:"Non Active", value:"non_active"}],
        default:[{text:"Yes", value:true}, { text:"No", value:"false"}],
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  props:{
    data:{
      type:Object
    }
  },
  computed:{
    country(){
      return this.input_data.country
    },
    state(){
      return this.input_data.state
    },
  },
  watch:{
    country(){
      if(this.input_data.country) this.getState()
    },
    state(){
      if(this.input_data.state) this.getCity()
    },
  },
  methods:{
    isEmpty(val){
      return val !== ""
    },
    isValidEmail(inputText)
    {
      let  mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      let result = false
      if(inputText.match(mailformat))
      {
        result = true;
      }
      return result
    },
    onSubmit(){
      let payload = {
        emp_id:this.$store.getters.empId,
        user_id:this.$store.getters.userId,
        referral_name:this.input_data.name,
        referral_referraltype_id:this.input_data.referral_type,
        referral_street:this.input_data.street,
        referral_country_id:(this.input_data.country == "" ? null:this.input_data.country),
        referral_state_id:(this.input_data.state == ""? null:this.input_data.state),
        referral_city_id:(this.input_data.city == "" ? null:this.input_data.city),
        referral_postal_code:this.input_data.postal_code,
        referral_phone:this.input_data.phone,
        referral_mobile:this.input_data.mobile,
        referral_email:this.input_data.email,
        referral_status:this.input_data.status == 'active' ? 1:0,
        referral_desc:this.input_data.desc,
      }

      if (this.data !== null){
        payload.id = this.data.id
        AxiosCall.Put(payload, urlApi.emergency_contact.update).then(res=>{
          if (res.success){
            this.$parent.getData()
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
          }else {
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.emergency_contact.add).then(res=>{
          if (res.success){
            this.$parent.getData()
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
          }else {
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }

    },
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.$parent.data = null
      this.title = "Add"
    },
    setData(){
      setTimeout(()=>{
        if (this.data !== null){
          this.title = "Edit"
          this.input_data = {
            name:this.data.name,
            referral_type:this.data.type_id,
            street:this.data.street,
            country:this.data.country,
            state:this.data.state,
            city:this.data.city,
            postal_code:this.data.postal_code,
            phone:this.data.phone_number,
            mobile:this.data.mobile,
            email:this.data.email,
            desc:this.data.desc,
            status:this.data.status == 1 ? 'active':'not_active',
            default:this.data.is_default==1? true:false,
            is_locked:"accepted"
          }
        }
      }, 100)
    },
    getReferralType(){
      let payload = {

      }
      AxiosCall.Get(payload, urlApi.emergency_contact.type).then(res=>{
        if(res.success){
          this.options.referral_type = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getCountry(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.country.list).then(res=>{
        if (res.success){
          this.options.country = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getState(){
      this.options.state = []
      this.input_data.state = ""

      if(this.input_data.country !== null){
        let payload = {
          country_id:this.input_data.country
        }
        AxiosCall.Get(payload, urlApi.state.combo).then(res=>{
          if(res.success){
            this.options.state = res.atributes
            if (this.data !== null)  {
              let found = this.options.state.some(el => el.id == this.data.state);
              this.input_data.state=(found ? this.data.state : "" )
            }
          }else {
            this.$parent.errorMessage(res.atributes)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }

    },
    getCity(){
      this.options.city = []
      this.input_data.city = ""
      if(this.input_data.state !== null){
        let payload = {state_id:this.input_data.state}
        AxiosCall.Get(payload, urlApi.city.combo).then(res=>{
          if(res.success){
            this.options.city = res.atributes
            if (this.data !== null ){
              let found = this.options.city.some(el=>el.id==this.data.city)
              this.input_data.city = (found ? this.data.city:"")
            }

          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
  },
  created() {
    this.getReferralType()
    this.getCountry()
  }
}
</script>